import {forwardRef} from '@chakra-ui/react';
import type {HTMLChakraProps, ComponentWithAs} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';

import {labelAnatomy, useLabelStyleConfig} from './theme';

export type LabelProps = {
  size?: `sm` | `md` | `lg`;
} & HTMLChakraProps<'div'>;

export const Label: ComponentWithAs<typeof ChakraDiv, LabelProps> = forwardRef<LabelProps, 'div'>((props, ref) => {
  const css = useLabelStyleConfig(props);
  return <ChakraDiv {...props} __css={{...css, ...props.__css}} ref={ref} {...labelAnatomy.root.attrs} />;
});
